import { render, staticRenderFns } from "./HotelsProveedorList.vue?vue&type=template&id=2a0e80b1&"
import script from "./HotelsProveedorList.vue?vue&type=script&lang=js&"
export * from "./HotelsProveedorList.vue?vue&type=script&lang=js&"
import style0 from "./HotelsProveedorList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCheckbox,VIcon,VSimpleTable})
